/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to invite a new member to the company
 * @export
 * @interface InviteMemberRequest
 */
export interface InviteMemberRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteMemberRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof InviteMemberRequest
     */
    role: InviteMemberRequestRoleEnum;
}


/**
 * @export
 */
export const InviteMemberRequestRoleEnum = {
    Admin: 'admin',
    Member: 'member'
} as const;
export type InviteMemberRequestRoleEnum = typeof InviteMemberRequestRoleEnum[keyof typeof InviteMemberRequestRoleEnum];


/**
 * Check if a given object implements the InviteMemberRequest interface.
 */
export function instanceOfInviteMemberRequest(value: object): value is InviteMemberRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function InviteMemberRequestFromJSON(json: any): InviteMemberRequest {
    return InviteMemberRequestFromJSONTyped(json, false);
}

export function InviteMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'role': json['role'],
    };
}

export function InviteMemberRequestToJSON(json: any): InviteMemberRequest {
    return InviteMemberRequestToJSONTyped(json, false);
}

export function InviteMemberRequestToJSONTyped(value?: InviteMemberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'role': value['role'],
    };
}

